/**
 * Authentication related constants
 */

export const BACKDOOR_TOKEN_KEY = 'BACKDOOR_TOKEN';
